// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";

// const PrivateRoute = ({ children }) => {
//   const [isApiHealthy, setIsApiHealthy] = useState(null);
//   const Token = localStorage.getItem("_ux98c_v1");

//   useEffect(() => {
//     const checkApiHealth = async () => {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_URL}/employee/employee`,
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${Token}`,
//             },
//           }
//         );

//         // API working fine if status is 200–299
//         if (response.ok) {
//           setIsApiHealthy(true);
//         } else {
//           setIsApiHealthy(false);
//         }
//       } catch (error) {
//         console.error("API health check failed:", error);
//         setIsApiHealthy(false);
//       }
//     };

//     if (Token) checkApiHealth();
//     else setIsApiHealthy(false);
//   }, [Token]);

//   // 🌀 Show bootstrap loader while checking API
//   if (isApiHealthy === null) {
//     return (
//       <div
//         className="d-flex justify-content-center align-items-center"
//         style={{ height: "100vh" }}
//       >
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Checking access...</span>
//         </div>
//       </div>
//     );
//   }

//   // If Token invalid or API not working → redirect
//   if (!Token || !isApiHealthy) return <Navigate to="/" />;

//   // Otherwise render protected component
//   return children;
// };

// export default PrivateRoute;


import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import loaderGif from "../src/assets/img/loader.gif";

const PrivateRoute = ({ children }) => {
  const [isApiHealthy, setIsApiHealthy] = useState(null);
  const Token = localStorage.getItem("_ux98c_v1");

  useEffect(() => {
    if (!Token) {
      setIsApiHealthy(false);
      return;
    }

    const checkApiHealth = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_URL}/employee/employee`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          }
        );

        setIsApiHealthy(response.ok);
      } catch (error) {
        console.error(error);
        setIsApiHealthy(false);
      }
    };

    checkApiHealth();
  }, [Token]);

  if (isApiHealthy === null) {
    return (
      <div className="loading-overlay">
        <img src={loaderGif} alt="Loading..." />
      </div>
    );
  }

  if (!Token || !isApiHealthy) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
